export default "__VITE_ASSET__DBrL7XRO__"